import React from 'react';
import { Star, Calendar } from 'lucide-react';
import { format } from 'date-fns';

const ReviewCard = ({ review }) => {
  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <Star
        key={i}
        className={`w-4 h-4 ${
          i < rating ? 'text-yellow-500 fill-current' : 'text-gray-300'
        }`}
      />
    ));
  };

  return (
    <div className="card">
      <div className="flex items-start gap-4">
        <img
          src={review.byUser?.avatar}
          alt={review.byUser?.name}
          className="w-12 h-12 rounded-full object-cover"
        />
        <div className="flex-1">
          <div className="flex items-center justify-between mb-2">
            <div>
              <h4 className="font-semibold text-gray-900">{review.byUser?.name}</h4>
              <div className="flex items-center gap-1">
                {renderStars(review.score)}
                <span className="text-sm text-gray-500 ml-1">({review.score}/5)</span>
              </div>
            </div>
            <div className="flex items-center gap-1 text-sm text-gray-500">
              <Calendar className="w-4 h-4" />
              {format(new Date(review.createdAt), 'MMM dd, yyyy')}
            </div>
          </div>
          <p className="text-gray-700">{review.text}</p>
        </div>
      </div>
    </div>
  );
};

export default ReviewCard;
